<template>
    <div class="nostock" :style="{zIndex: zIndexNum,}">
      <!-- <img :src="src" class="nostockImg" alt="" /> -->
      <div class="restock-text">{{getDFLANG()?'Sold Out': '已抢光'}}</div>
    </div>
  </template>
  
  <script>
  import {
  unionFlag,
} from "../utils";
import { publicFunc } from "../utils/func";
  export default {
    props: {
      zIndexNum: {
        type: Number,
        required: false,
      },
      src:{
        type:String,
        default:require("@/assets/imgs/nostock.png")
      }
    },
    methods: {
      getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return publicFunc.getCookie("df_lang") == "en-US" && union;
    },
  }
  };
  </script>
  
  <style lang="less" scoped>
  @375: 320/375;
  .nostock {
    position: absolute;
    width: 100%;
    display: flex;
    min-height: auto;
    height: 100%;
    top: 0;
    left: 0;
    z-index:10;
    justify-content: center;
    align-items: center;
    img.nostockImg{
      width: 80%;
      display: block;
    }
    .restock-text{
      width: 70px;
      height: 28px;
      line-height: 28px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 14px * @375;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  </style>
  